import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Cookies from "js-cookie";

const BaseURL = process.env.REACT_APP_API_URL;

export const GetCollectionManParties = createAsyncThunk(
    'CollectionMan/GetCollectionManParties',
    async (_, { rejectWithValue }) => {
        try {
            const token = Cookies.get('authToken');
            const DataBase = Cookies.get('Database');
            const SqlId = Cookies.get('SqlId');
            const Fyear = Cookies.get('FinancialYear');

            if (!SqlId) {
                return rejectWithValue('SqlId is missing from cookies');
            }

            const response = await axios.post(`${BaseURL}/CollectionMan/CollectionManParty`, {
                DataBase: DataBase,
                CollectionManID: SqlId,
                Fyear: Fyear
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const GetBankRecBank = createAsyncThunk(
    'CollectionMan/GetBankRecBank',
    async (_, { rejectWithValue }) => {
        try {
            const token = Cookies.get('authToken');
            const DataBase = Cookies.get('Database');

            const response = await axios.post(`${BaseURL}/CollectionMan/BankRecBank`, {
                DataBase: DataBase
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const UpdateCollectionManLatLog = createAsyncThunk(
    'CollectionMan/UpdateCollectionManLatLog',
    async ({ PartyID, Latitude, Longitude }, { rejectWithValue }) => {
        try {
            const token = Cookies.get('authToken');
            const DataBase = Cookies.get('Database');

            const response = await axios.post(`${BaseURL}/CollectionMan/UpdateLatLog`, {
                DataBase: DataBase,
                PartyID: PartyID,
                Latitude: Latitude,
                Longitude: Longitude
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const PostPartyCollection = createAsyncThunk(
    'CollectionMan/PostPartyCollection',
    async (data, { rejectWithValue }) => {
        try {
            const token = Cookies.get('authToken');
            const DataBase = Cookies.get('Database');
            const Fyear = Cookies.get('FinancialYear');
            const SqlId = Cookies.get('SqlId');

            const response = await axios.post(`${BaseURL}/CollectionMan/PartyCollection`, {
                DataBase: DataBase,
                Fyear: Fyear,
                CollectionManID: SqlId,
                ...data
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const PartyWiseSchedulePost = createAsyncThunk(
    'CollectionMan/PartyWiseSchedulePost',
    async (data, { rejectWithValue }) => {
        try {
            const token = Cookies.get('authToken');
            const DataBase = Cookies.get('Database');
            const Fyear = Cookies.get('FinancialYear');
            const SqlId = Cookies.get('SqlId');

            const response = await axios.post(`${BaseURL}/CollectionMan/PartyWiseSchedulePost`, {
                DataBase: DataBase,
                Fyear: Fyear,
                CollectionManID: SqlId,
                ...data
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const GetSchedulePost = createAsyncThunk(
    'CollectionMan/GetSchedulePost',
    async (data, { rejectWithValue }) => {
        try {
            const token = Cookies.get('authToken');
            const DataBase = Cookies.get('Database');
            const Fyear = Cookies.get('FinancialYear');
            const SqlId = Cookies.get('SqlId');

            const response = await axios.post(`${BaseURL}/CollectionMan/GetSchedulePost`, {
                DataBase: DataBase,
                Fyear: Fyear,
                CollectionManID: SqlId,
                ...data
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const PartywiseGetSchedulePost = createAsyncThunk(
    'CollectionMan/PartywiseGetSchedulePost',
    async (data, { rejectWithValue }) => {
        try {
            const token = Cookies.get('authToken');
            const DataBase = Cookies.get('Database');
            const Fyear = Cookies.get('FinancialYear');
            const SqlId = Cookies.get('SqlId');

            const response = await axios.post(`${BaseURL}/CollectionMan/PartywiseGetSchedulePost`, {
                DataBase: DataBase,
                Fyear: Fyear,
                CollectionManID: SqlId,
                ...data
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const GetPartyWiseCollactionData = createAsyncThunk(
    'CollectionMan/GetPartyWiseCollactionData',
    async ({ PartyID }, { rejectWithValue }) => {
        try {
            const token = Cookies.get('authToken');
            const DataBase = Cookies.get('Database');
            const Fyear = Cookies.get('FinancialYear');
            const SqlId = Cookies.get('SqlId');

            const response = await axios.post(`${BaseURL}/CollectionMan/PartyWiseCollactionData`, {
                DataBase: DataBase,
                Fyear: Fyear,
                CollectionManID: SqlId,
                PartyID: PartyID
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);
export const GetCollactionData = createAsyncThunk(
    'CollectionMan/GetCollactionData',
    async (_, { rejectWithValue }) => {
        try {
            const token = Cookies.get('authToken');
            const DataBase = Cookies.get('Database');
            const Fyear = Cookies.get('FinancialYear');
            const SqlId = Cookies.get('SqlId');

            const response = await axios.post(`${BaseURL}/CollectionMan/CollactionData`, {
                DataBase: DataBase,
                Fyear: Fyear,
                CollectionManID: SqlId
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const CollectionAging = createAsyncThunk(
    'CollectionMan/CollectionAging',
    async (data, { rejectWithValue }) => {
        try {
            const token = Cookies.get('authToken');
            const DataBase = Cookies.get('Database');
            const Fyear = Cookies.get('FinancialYear');
            const SqlId = Cookies.get('SqlId');

            const response = await axios.post(`${BaseURL}/CollectionMan/CollectionAging`, {
                DataBase: DataBase,
                Fyear: Fyear,
                CollectionManID: SqlId,
                ...data
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);

const collectionManSlice = createSlice({
    name: 'CollectionMan',
    initialState: {
        partiesList: [],
        banksList: [],
        paymentTypesList: [],
        partyWiseCollectionList: [],
        collectionList: [],
        scheduleList: [],
        agingData: [],
        loading: false,
        banksLoading: false,
        partyWiseCollectionLoading: false,
        collectionLoading: false,
        scheduleLoading: false,
        agingLoading: false,
        error: null,
    },
    reducers: {
        clearPartiesError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetCollectionManParties.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetCollectionManParties.fulfilled, (state, action) => {
                state.loading = false;
                state.partiesList = action.payload.Data || [];
            })
            .addCase(GetCollectionManParties.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(GetBankRecBank.pending, (state) => {
                state.banksLoading = true;
                state.error = null;
            })
            .addCase(GetBankRecBank.fulfilled, (state, action) => {
                state.banksLoading = false;
                state.banksList = action.payload.Data || [];
                state.paymentTypesList = action.payload.Data1 || [];
            })
            .addCase(GetBankRecBank.rejected, (state, action) => {
                state.banksLoading = false;
                state.error = action.payload;
            })
            .addCase(GetPartyWiseCollactionData.pending, (state) => {
                state.partyWiseCollectionLoading = true;
                state.error = null;
            })
            .addCase(GetPartyWiseCollactionData.fulfilled, (state, action) => {
                state.partyWiseCollectionLoading = false;
                state.partyWiseCollectionList = action.payload.Data || [];
            })
            .addCase(GetPartyWiseCollactionData.rejected, (state, action) => {
                state.partyWiseCollectionLoading = false;
                state.error = action.payload;
            })
            .addCase(GetCollactionData.pending, (state) => {
                state.collectionLoading = true;
                state.error = null;
            })
            .addCase(GetCollactionData.fulfilled, (state, action) => {
                state.collectionLoading = false;
                state.collectionList = action.payload.Data || [];
            })
            .addCase(GetCollactionData.rejected, (state, action) => {
                state.collectionLoading = false;
                state.error = action.payload;
            })
            .addCase(GetSchedulePost.pending, (state) => {
                state.scheduleLoading = true;
                state.error = null;
            })
            .addCase(GetSchedulePost.fulfilled, (state, action) => {
                state.scheduleLoading = false;
                state.scheduleList = action.payload.Data || [];
            })
            .addCase(GetSchedulePost.rejected, (state, action) => {
                state.scheduleLoading = false;
                state.error = action.payload;
            })
            .addCase(PartywiseGetSchedulePost.pending, (state) => {
                state.scheduleLoading = true;
                state.error = null;
            })
            .addCase(PartywiseGetSchedulePost.fulfilled, (state, action) => {
                state.scheduleLoading = false;
                state.scheduleList = action.payload.Data || [];
            })
            .addCase(PartywiseGetSchedulePost.rejected, (state, action) => {
                state.scheduleLoading = false;
                state.error = action.payload;
            })
            .addCase(CollectionAging.pending, (state) => {
                state.agingLoading = true;
                state.error = null;
            })
            .addCase(CollectionAging.fulfilled, (state, action) => {
                state.agingLoading = false;
                state.agingData = action.payload.Data || [];
            })
            .addCase(CollectionAging.rejected, (state, action) => {
                state.agingLoading = false;
                state.error = action.payload;
            });
    },
});

export const { clearPartiesError } = collectionManSlice.actions;
export default collectionManSlice.reducer;